import useInputWithReset from '../../../hooks/input-hooks/useInputWithReset'

import { currentBikeDetailsForm as form } from '../../../forms/form-objects/prefitInterviewFormObjects'

import {
  getInput,
  getValidation,
  getForm
} from '../../../hooks/input-hooks/inputFunctions'

const useCurrentBikeDetailsForm = (record) => {
  const keyArray = Object.keys(form)
  const i = []

  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )
  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )
  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )
  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )
  i[i.length] = useInputWithReset(
    getInput(form, keyArray, i.length, record),
    getValidation(form, keyArray, i.length)
  )

  return getForm(keyArray, i)
}

export default useCurrentBikeDetailsForm
